import 'whatwg-fetch';
import { AUTH_SERVICE } from '../constants/auth';

export const fetch = window.fetch;

/**
 *
 * @param endpoint
 * @param options
 */
export const authFetch = async (endpoint: string, options?: any) => {
    let response, data;
    try {
        const url = `${AUTH_SERVICE}${endpoint}`;
        response = await fetch(url, {
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            redirect: 'manual',
            ...options,
        });
    } catch (error) {
        throw new Error('UNKNOWN');
    }

    if (response.ok) {
        try {
            data = await response.json();
            return { data };
        } catch (error) {
            return { data: {} };
        }
    } else {
        try {
            data = await response.json();
        } catch (error) {
            if (response.status === 401) {
                throw new Error('USER_NOT_LOGGED_IN');
            }
            throw new Error('UNKNOWN');
        }
        const errorCode = data?.errorCode;
        if (errorCode) {
            throw new Error(errorCode);
        }
        if (response.status === 401) {
            throw new Error('USER_NOT_LOGGED_IN');
        }
        throw new Error('UNKNOWN');
    }
};

export default {
    authFetch,
};
